<template>
  <div>
    <Loading v-if="showSpinner" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MAIN_ITEM_LOCAL_STORAGE } from './constants'

export default {
  computed: mapGetters({
    showSpinner: 'main/loading'
  }),
  beforeMount() {
    const retrievedObject = JSON.parse(
      localStorage.getItem(MAIN_ITEM_LOCAL_STORAGE)
    )
    if (retrievedObject) {
      this.$store.commit('auth/setDataFromLocalStorage', retrievedObject)
    }
  }
}
</script>
